module.exports = __webpack_public_path__ + "img/img40.c6e39285.svg";